import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./termsPopup.module.css";
import {
  getAccountSecurityArray,
  getAdditionalTermsArray,
  getAssistanceServiceArray,
  getDisclaimerTermsArray,
  getDoNotsTermsArray,
  getEmergencyTermsArray,
  getIntellectualPropertyTermsArray,
  getLiabilityTermsArray,
  getProhibitedContentArray,
  getProvidersTermsArray,
  getRegistrationTermsArray,
  getSupportsTermsArray,
  getTermsArrayGeneral,
} from "../../utils/utils";
import logo from "../../images/logo_terms.jpg";
import i18n from "../../i18n";

function TermsPopup({ onClose }: { onClose: () => void }) {
  return (
    <section className={styles.terms} dir={i18n.dir()}>
      <img src={logo} alt={t("LOGO")} className={styles.terms__logo} />
      <h2 className={`${styles.terms__title} ${styles.terms__title_main}`}>
        {t("TERMS_OF_USE_BIPERIVAN")}
      </h2>
      <h3 className={styles.terms__subtitle}>{t("GUIDELINES")}</h3>
      <ul className={styles.terms__list}>
        {getTermsArrayGeneral().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>
        {t("CONTACT_INFORMATION_FOR_EMERGENCY")}
      </h3>
      <ul className={styles.terms__list}>
        {getEmergencyTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>
        {t("CIRCUMSTANCES_FOR_CONFIDENTIALITY")}
      </h3>
      <ul className={styles.terms__list}>
        {getAdditionalTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("ELIGIBILITY_FOR_ACCOUNT")}</h3>
      <ul className={styles.terms__list}>
        {getRegistrationTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("MY_ACCOUNT")}</h3>
      <ul className={styles.terms__list}>
        {getAccountSecurityArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("REASONABLE_USE")}</h3>
      <ul className={styles.terms__list}>
        <li className={styles.terms__li}>{t("AGREE_NOT_TO_USE_ILLEGALLY")}</li>
        <h3 className={styles.terms__subtitle}>
          {t("MESSAGE_AND_INFO_PSEUDONYM")}
        </h3>
        <h4 className={styles.terms__subtitle_thin}>
          {t("NO_PUBLICATION_OR_TRANSFER")}
        </h4>
        <ul className={styles.terms__list}>
          {getProhibitedContentArray().map((item, index) => (
            <li key={index} className={styles.terms__li}>
              {t(item.text)}
            </li>
          ))}
        </ul>
        <h3 className={styles.terms__subtitle}>
          {t("NO_INTERFERE_WITH_SERVICE")}
        </h3>
        <li className={styles.terms__li}>{t("MALWARE_AND_ATTACKS")}</li>
        <li className={styles.terms__li}>{t("USAGE_OF_HARMFUL_SERVICES")} </li>
        <li className={styles.terms__li}>{t("COMPANY_NOT_RESPONSIBLE")}</li>
        <li className={styles.terms__li}>{t("APP_DOWNLOAD_AGREEMENT")}</li>
      </ul>
      <h3 className={styles.terms__subtitle}>{t("PAYMENT")}</h3>
      <ul className={styles.terms__list}>
        {getAssistanceServiceArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("SUPPLIERS")}</h3>
      <ul className={styles.terms__list}>
        {getProvidersTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("INTELLECTUAL_PROPERTY")}</h3>
      <ul className={styles.terms__list}>
        {getIntellectualPropertyTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("LICENSE_NOT_PERMITTED")}</h3>
      <ul className={styles.terms__list}>
        {getDoNotsTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("WAIVER_DOCUMENTS")}</h3>
      <ul className={styles.terms__list}>
        {getDisclaimerTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>
        {t("LIMITATIONS_OF_LIABILITY")}
      </h3>
      <ul className={styles.terms__list}>
        {getLiabilityTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>{t("HYPERLINKS")}</h3>
      <ul className={styles.terms__list}>
        <li className={styles.terms__li}>{t("LINKS_AND_THIRD_PARTY_SITES")}</li>
      </ul>
      <h3 className={styles.terms__subtitle}>{t("END_OF_SESSION")}</h3>
      <ul className={styles.terms__list}>
        <li className={styles.terms__li}>{t("BIPRIVAN_RIGHTS_AND_TERMS")}</li>
      </ul>
      <h3 className={styles.terms__subtitle}>{t("SUPPORT_TERMS")}</h3>
      <ul className={styles.terms__list}>
        {getSupportsTermsArray().map((i) => (
          <li key={i.id} className={styles.terms__li}>
            {t(i.text)}
          </li>
        ))}
      </ul>
      <h3 className={styles.terms__subtitle}>
        {t("LAW_APPLIES_AND_DISPUTES")}
      </h3>
      <h4 className={styles.terms__subtitle}>{t("USERS_IN_ISRAEL")}</h4>
      <p className={styles.terms__li}>{t("TERMS_AND_DISPUTES_ISRAEL")} </p>
      <h3 className={styles.terms__subtitle}>{t("GUIDELINES")}</h3>
      <p className={styles.terms__li}>{t("BIPRIVAN_TERMS_ENFORCEMENT")}</p>
      <button className={"button"} onClick={onClose}>
        {t("CLOSE")}
      </button>
    </section>
  );
}

export default TermsPopup;
